import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export function animation() {

	window.addEventListener("load", () => {

		// const sectionHeight = section.offsetHeight;
		// const vh = window.innerHeight;

		// ====== ブレイクポイント設定（例: 768px以下をスマホとする） ======
		const isMobile = window.matchMedia("(max-width: 768px)").matches;

		if (isMobile) {
			console.log('aaa');

			gsap.registerPlugin(ScrollTrigger);

			// ==============================
			// タイトル：中央固定 + ブラー
			// ==============================
			gsap.to(".j-tagline", {
				// filter: "blur(8px)",
				// ease: "power2.inOut",
				scrollTrigger: {
					trigger: ".j-tagline",
					start: "center center",
					endTrigger: ".j-taglinePin", // p-home_fv が画面外に出るまで
					end: "bottom bottom",
					//   scrub: true, // ★固定中のブラー強弱が自然になる
					pin: true,
					pinSpacing: false, // ★ 下余白によるズレ防止
					// toggleActions: "play reverse play reverse",
					// toggleActions: "play none none reverse",
					// markers: true,
				},
			});

			gsap.to(".j-tagline", {
				filter: "blur(5px)",
				opacity: 0.1,
				duration: 0.5,
				ease: "power2.inOut",
				scrollTrigger: {
					trigger: ".j-taglineTxt", // .p-home_fv_message_btn に j-message_end クラスを付与
					start: "top 80%",    // ボタンが画面中央に来たとき
					endTrigger: ".j-taglinePin", // p-home_fv が画面外に出るまで
					end: "bottom bottom",
					toggleActions: "play none none reverse",
					// scrub: true,
					scrub: false,
					// markers: true,
				},
			});

			ScrollTrigger.refresh();
		}

    });
}
